const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

export const apiBaseUrl =
  configuredApiBaseUrl || (process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:5000' : '');

export const buildApiUrl = (path: string) => {
  if (!path) {
    return apiBaseUrl;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiBaseUrl}${normalizedPath}`;
};
